var _circle, _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKrik(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 25,
    fill: "#FAF3F3",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.875 18.265C37.875 19.8925 36.9236 21.3313 36.3064 22.2639C36.2961 22.2794 36.2859 22.2948 36.2758 22.3101C36.1285 22.5326 36.0034 22.7215 35.9049 22.8867C35.8733 22.9398 35.8467 22.9868 35.8245 23.0282C36.4605 22.9967 37.106 22.5623 37.6226 21.7253C38.1546 20.8634 38.5 19.6413 38.5 18.265C38.5 16.8887 38.1546 15.6666 37.6226 14.8047C37.106 13.9677 36.4605 13.5333 35.8245 13.5018C35.8467 13.5432 35.8733 13.5902 35.9049 13.6433C36.0034 13.8085 36.1285 13.9974 36.2758 14.2199C36.2859 14.2352 36.2961 14.2506 36.3064 14.2661C36.9236 15.1987 37.875 16.6375 37.875 18.265Z",
    fill: "#FA8F44",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8495 18.6137C34.8495 19.9565 34.0101 21.1336 33.4832 21.8725L33.4762 21.8824C33.4675 21.8945 33.459 21.9065 33.4505 21.9184C33.3452 22.066 33.2544 22.1934 33.179 22.3064C33.6563 22.2259 34.1276 21.8951 34.5133 21.3152C34.9584 20.6458 35.25 19.6922 35.25 18.6137C35.25 17.5353 34.9584 16.5817 34.5133 15.9123C34.1276 15.3324 33.6563 15.0016 33.179 14.9211C33.2544 15.0341 33.3452 15.1615 33.4505 15.3091C33.459 15.321 33.4675 15.333 33.4762 15.3451L33.4832 15.355C34.0101 16.0938 34.8495 17.271 34.8495 18.6137Z",
    fill: "#FA8F44",
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 34.2397C13.5 29.0497 18.9715 24.6429 26 24.6429C33.0285 24.6429 38.5 29.0497 38.5 34.2397C38.5 35.544 38.1621 36.4003 37.6133 36.9869C37.055 37.5836 36.2179 37.9668 35.0922 38.1969C33.9669 38.4269 32.6076 38.4935 31.0582 38.4995C30.2861 38.5026 29.4746 38.4907 28.6275 38.4779L28.5705 38.477C27.7424 38.4646 26.8816 38.4516 26 38.4516C25.1184 38.4516 24.2576 38.4646 23.4295 38.477L23.3725 38.4779C22.5254 38.4907 21.7139 38.5026 20.9418 38.4995C19.3924 38.4935 18.033 38.4269 16.9078 38.1969C15.7821 37.9668 14.945 37.5836 14.3867 36.9869C13.8379 36.4003 13.5 35.544 13.5 34.2397Z",
    fill: "#FA8F44",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 18.5715,
    r: 5.07143,
    transform: "rotate(-180 26 18.5715)",
    fill: "#FA8F44",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9_219",
    x: 9,
    y: 13,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_219"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_219",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrik);
export default __webpack_public_path__ + "static/media/Krik.6984c4611a293fd34db3fdd06bac5a6d.svg";
export { ForwardRef as ReactComponent };